import BodyText from "components/Typography/BodyText"
import { memo, useMemo } from "react"
import styled from "styled-components"
import { Colors } from "themes/palette"
import CreateWebhookButton from "./CreateWebhookButton"

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 48px 24px 0px 44px;
  height: 50vh;
  width: 90%;
  background-color: ${Colors.white_alt_soft};
  box-shadow: 0px 2px 10px 0px ${Colors.black_alt_soft};
  border-radius: 12px;
`
const ContainerBox = styled.div`
  width: 330px;
  display: flex;
  gap: 60px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`

interface Props {
  filterValue: string
}
const WebhookBoard = (props: Props) => {
  const { filterValue } = props

  const label = useMemo(() => {
    if (filterValue) return "Você ainda não criou nenhum Webhook para esse produto"

    return "Você ainda não criou nenhum Webhook"
  }, [filterValue])

  return (
    <Container>
      <ContainerBox>
        <BodyText weight="semi-bold" size="medium" color="gray-dark">
          {label}
        </BodyText>
        <CreateWebhookButton title="Criar Webhook" />
      </ContainerBox>
    </Container>
  )
}

export default memo(WebhookBoard)
